export interface RemoteDefinitionsOptions {
  hostLocalPort?: string;
  remoteEntryFile?: string;
  hostedAppsPathPrefix?: string;
}

const defaults: Required<RemoteDefinitionsOptions> = {
  hostLocalPort: '4300',
  remoteEntryFile: 'remoteEntry.mjs',
  hostedAppsPathPrefix: '/apps',
};

export function buildRemoteDefinitions(
  remotes: Record<string, number>,
  fn: (repo: string, port: number) => string
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(remotes).map(([repo, port]) => [repo, fn(repo, port)])
  );
}

export function getRemoteDefinitions(
  loc: { hostname: string; port: string; origin: string },
  remotes: Record<string, number>,
  options: RemoteDefinitionsOptions = {}
): Record<string, string> {
  const config = { ...defaults, ...options };

  console.log('Remote definitions defaults/options', defaults, options);
  console.log('Remote definitions remotes/options', remotes, options);

  if (loc.hostname === 'localhost' && loc.port === config.hostLocalPort) {
    return buildRemoteDefinitions(remotes, (_repo, port) => {
      return `http://localhost:${port}/${config.remoteEntryFile}`;
    });
  }

  return buildRemoteDefinitions(remotes, (repo) => {
    return `${loc.origin}${config.hostedAppsPathPrefix}/${repo}/${config.remoteEntryFile}`;
  });
}
